import { z } from 'zod';
export const crmConnectionSchema = z.object({
    url: z.url({ protocol: /^https?$/, error: 'Enter the company’s SmartOn address, e.g. https://yourcompany.smarton.app' }).max(200),
    /** Write-only. Null keeps the stored key. */
    key: z.string().trim().max(200).nullable(),
});
export const crmSettingsSchema = z.object({
    saleEventTypeId: z.number().int().positive().nullable(),
    users: z.array(z.object({ id: z.uuid(), crmPersonId: z.number().int().positive().nullable(), salesPerson: z.boolean() })).max(2000),
    queues: z.array(z.object({ id: z.uuid(), sales: z.boolean() })).max(500),
});
/** A call SmartOn asks for: the sales event it is for goes with it. */
export const crmCallIntentSchema = z.object({
    number: z.string().trim().min(2).max(32),
    saleEventId: z.number().int().positive(),
});
export function isCrmWindowMessage(data) {
    if (!data || typeof data !== 'object')
        return false;
    const message = data;
    if (message.type !== 'smarton-pbx')
        return false;
    if (message.action === 'call') {
        return typeof message.number === 'string' && message.number.length <= 32 && (message.saleEventId === undefined || Number.isInteger(message.saleEventId));
    }
    return message.action === 'answer' && typeof message.callId === 'string' && message.callId.length <= 64;
}
